import { render, staticRenderFns } from "./rank-data-box.vue?vue&type=template&id=00cbe7c9"
import script from "./rank-data-box.vue?vue&type=script&lang=ts"
export * from "./rank-data-box.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports